/* eslint-disable no-undef */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Spacer from '../components/Spacer';

function FAQ() {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const question = searchParams.get('question');
  const insuranceAnswer = t('faq.insurance-question.answer');
  const insuranceTitle = t('faq.insurance-question.title');
  const formattedInsuranceTitle = question === 'insurance-question' ? <strong>{insuranceTitle}</strong> : insuranceTitle;
  const formattedInsuranceAnswer = insuranceAnswer.includes('I.E.H.P') ? insuranceAnswer.replace('I.E.H.P', '<strong>I.E.H.P</strong>') : insuranceAnswer;
  const prideTitle = t('faq.question7.title');
  const formattedPrideTitle = question === 'pride-question' ? <strong>{prideTitle}</strong> : prideTitle;

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && question) {
      const container = document.getElementById(`${question}-container`);
      if (container) {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [question]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: t('faq.insurance-question.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.insurance-question.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question1.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question1.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question2.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question2.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question3.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question3.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question4.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question4.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question7.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question7.answer'),
                },
              },
              {
                '@type': 'Question',
                name: t('faq.question6.title'),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: t('faq.question6.answer'),
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Spacer />
      <div className="container" style={{ minHeight: 1000 }}>
        <h1 className="display-4 text-primary mb-4 text-center">{t('faq.title')}</h1>
        <div className="faq-content text-primary">
          <div id="insurance-question-container">
            <h2 id="insurance-question">{formattedInsuranceTitle}</h2>
            <p dangerouslySetInnerHTML={{ __html: formattedInsuranceAnswer }}></p>
          </div>

          <h2>{t('faq.question1.title')}</h2>
          <p>{t('faq.question1.answer')}</p>

          <h2>{t('faq.question2.title')}</h2>
          <p>{t('faq.question2.answer')}</p>

          <h2>{t('faq.question3.title')}</h2>
          <p>{t('faq.question3.answer')}</p>

          <h2>{t('faq.question4.title')}</h2>
          <p>{t('faq.question4.answer')}</p>

          <div id="pride-question-container">
            <h2 id="pride-question">{formattedPrideTitle}</h2>
            <p>{t('faq.question7.answer')}</p>
          </div>

          <h2>{t('faq.question6.title')}</h2>
          <p>{t('faq.question6.answer')}</p>
        </div>
      </div>
    </>
  );
}

export default FAQ;
